module.exports = __webpack_public_path__ + "img/image16.eef8487e.jpg";